export const msalConfig = {
    auth: {
        // App in Entra ID
        clientId: "6e2883bc-544f-4376-939f-332bde4ac2bd",

        // Directory ID
        authority: "https://login.microsoftonline.com/82e572e7-0b33-455c-843a-2887c4cf941f",

        redirectUri: window.location.hostname === "localhost"
            ? "http://localhost:3000"
            : "https://www.sspnorth.com/simplifier-configurator/",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};